export enum KeyboardKeysEnum {
  ArrowUp = 'SETA CIMA',
  ArrowDown = 'SETA BAIXO',
  ArrowLeft = 'SETA ESQUERDA',
  ArrowRight = 'SETA DIREITA'
}
